<script setup lang="ts">
import { Eye, EyeOff } from 'lucide-vue-next';
import { ref } from 'vue';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

defineProps<{
    id: string;
}>();

const password = defineModel<string>({ required: true });
const showPassword = ref(false);
</script>

<template>
    <div class="flex items-center gap-2">
        <Input
            :id="id"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="off"
            required
        />
        <Button
            type="button"
            variant="outline"
            class="px-3"
            @click="showPassword = !showPassword"
        >
            <Eye v-if="!showPassword" class="h-4 w-4" />
            <EyeOff v-else class="h-4 w-4" />
        </Button>
    </div>
</template>
